<template>
<v-dialog v-model="show" max-width="400">
  <template v-slot:activator="{on}">
    <slot name="activator" :on="on">
      <v-btn>button</v-btn>
    </slot>
  </template>
  <v-card>
    <CardTitle title="SDP Chart" dense>
      <template v-slot:actions>
        <v-btn @click="show = false" icon><v-icon>close</v-icon></v-btn>
      </template>
    </CardTitle>
    <v-card-text>
      <v-img v-if="show" :src="`https://wa.conan.conflabs.com/api/CVKntq2Mip/graphing/png/radar/${sample_id}/terpenes`"></v-img>
    </v-card-text>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  name: "SdpView",
  props: {
    sample_id: {
      required: true,
    }
  },
  data: () => ({
    show: false,
  }),
  mounted() {
  },
  methods: {}
}
</script>

<style scoped>

</style>
